import { DiscountType } from '@ibk/shared-types';
export const DEFAULT_CURRENCY_VALUE = 'R$ 0,00';
export const DEFAULT_PERCENTAGE_VALUE = '0,00%';
export const applyMask = (value, type) => {
    const numbers = value.replace(/\D/g, '');
    if (type === DiscountType.TOTAL) {
        if (numbers === '')
            return DEFAULT_CURRENCY_VALUE;
        const formattedNumber = numbers.padStart(3, '0');
        const reais = formattedNumber.slice(0, -2);
        const centavos = formattedNumber.slice(-2);
        const formattedReais = parseInt(reais).toLocaleString('pt-BR');
        return `R$ ${formattedReais},${centavos}`;
    }
    else {
        if (numbers === '')
            return DEFAULT_PERCENTAGE_VALUE;
        const digits = numbers.padStart(3, '0');
        const inteiros = digits.slice(0, -2);
        const decimais = digits.slice(-2);
        return `${parseInt(inteiros)},${decimais}%`;
    }
};
export const handleDiscountBackspace = (currentValue, discountType) => {
    const currentNumbers = currentValue.replace(/\D/g, '');
    const newNumbers = currentNumbers.slice(0, -1);
    if (!newNumbers) {
        return discountType === DiscountType.TOTAL ? DEFAULT_CURRENCY_VALUE : DEFAULT_PERCENTAGE_VALUE;
    }
    if (discountType === DiscountType.PERCENTAGE) {
        const numericValue = parseFloat(newNumbers) / 100;
        if (numericValue > 100) {
            return '100,00%';
        }
    }
    return applyMask(newNumbers, discountType);
};
